import React, {useMemo} from "react";
import AppLogo from "./AppLogo";
import RightTopIcon from "../../assets/countdown/right-top-icon.png";
import TitleLogo from "../../assets/img/title_logo.png";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
  logoRoot: {
    padding: 5,
    maxWidth: '13.5vw'
  },
  logoIm: {
    width: props => props.width,
    maxWidth: '100%',
    height: 'auto'
  },
  rightTopIconRoot: {
    padding: 5,
    maxWidth: props => props.isSpecial ? 'unset' : '13.5vw'
  },
  rightTopIcon: {
    width: props => props.width,
    maxWidth: '100%',
    float: 'right'
  }
})

const AppHeader = ({isSpecial}) => {
  const [width, setWidth] = React.useState(window.innerWidth > 900 ? window.innerWidth * 0.2: window.innerWidth * 0.4);

  const classes = useStyles({isSpecial, width})

  React.useEffect(() => {
    function handleResize() {
      if (window.innerWidth > 900) {
        setWidth(window.innerWidth * 0.24)
      } else {
        setWidth(window.innerWidth * 0.44)
      }
    }
    window.addEventListener('resize', handleResize)
  }, [])

  return(
    <div className={'header-container'}>
      <AppLogo />
      <div>
        {
          !isSpecial && <div className={classes.logoRoot}>
            <img  alt={''} src={TitleLogo} className={classes.logoIm}/>
          </div>
        }
        <div className={classes.rightTopIconRoot}>
          <img alt={'The business times'} className={classes.rightTopIcon} src={RightTopIcon} />
        </div>
      </div>
    </div>
  )
}

export default AppHeader;